import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryPayableUnverifiedOrderFunc(requestBody) {
  return request({
    url: URL.finance.payableUnverifiedOrder.query,
    method: 'post',
    data: requestBody
  })
}

export function handlePayableUnverifiedOrderFunc(requestBody) {
  return request({
    url: URL.finance.payableUnverifiedOrder.handle,
    method: 'post',
    data: requestBody
  })
}

export function manualGeneratePayableUnverifiedOrderFunc() {
  return request({
    url: URL.finance.payableUnverifiedOrder.manualGenerate,
    method: 'post'
  })
}
